import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/shared/services/api/customFetchBase';
import { removeCookie } from '@/shared/services/storage/cookieService';

interface UserInfoResponse {
  code?: number;
  data?: any;
  [key: string]: any;
}

interface SignOutResponse {
  success: boolean;
  [key: string]: any;
}

const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: customFetchBase('https://gotomztol.img-cdn-cloud.com'),
  tagTypes: ['UserInfo'],
  endpoints: (build) => ({
    getUserInfo: build.query<UserInfoResponse, void>({
      query: () => ({
        url: `/api/user/keywordyab/info`,
        method: 'GET'
      }),
      providesTags: [{ type: 'UserInfo' as const }],
      transformResponse: (response: unknown): UserInfoResponse => {
        const data = response as UserInfoResponse;
        if (!data || data.code !== 200) {
          removeCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME, true);
          removeCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME, true);
          window.location.replace('/login');
        }
        return data;
      },
      transformErrorResponse: (error: unknown) => {
        const err = error as { status?: number; data?: { status?: number } };
        if (err?.status === 500 || err?.data?.status === 500) {
          removeCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME, true);
          removeCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME, true);
          window.location.replace('/login');
        }
        return error;
      }
    }),
    signOut: build.mutation<SignOutResponse, void>({
      query: () => ({
        url: `/api/user/signout`,
        method: 'POST'
      }),
      transformResponse: (response: unknown): SignOutResponse => {
        const data = response as SignOutResponse;
        if (data.success) {
          removeCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME, true);
          removeCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME, true);
          window.location.replace(`${import.meta.env.VITE_ACCOUNT_SERVER_URL}/logout`);
        }
        return data;
      }
    })
  })
});

export const { useGetUserInfoQuery, useSignOutMutation } = authApi;

export default authApi;

